document.addEventListener("DOMContentLoaded", function () {
  var radioButtons = document.querySelectorAll('[type="radio"]');

  radioButtons.forEach(function (radioButton) {
   
    radioButton.addEventListener("change", function () {

       console.log(radioButton);

      var selectedVariantId = radioButton.dataset.variantid;
      
      // Match the selected variant with the data from the script
      var variantJSON = document.querySelector("#variant_prices").textContent;
      var variantPrices = JSON.parse(variantJSON);

      // Find the matching variant in the variantPrices data
      var matchingVariant = variantPrices.variants.find(function (variant) {
        return variant.variant_id === selectedVariantId;
      });

      // Display the prices based on the matching variant
      if (matchingVariant) {
        document.querySelector("#vat_plus_price").textContent = matchingVariant.total_tax_price + ' inc. VAT';
        document.querySelector("#price_per_unit").textContent = matchingVariant.price_per_unit;
        console.log("Variant Price:", matchingVariant.variant_price);
        console.log("Total Tax Price:", matchingVariant.total_tax_price);
        console.log("Saved Tax:", matchingVariant.price_save);

        // You can update the UI with the prices as needed
      }


      
    });
  });

    
  const swatches = document.querySelectorAll('.swatch');
    swatches.forEach( function(item) {
      console.log('work');
       const heading = item.querySelector(".current-option");
       const selectedOption = item.querySelector("input:checked");
       heading.textContent = selectedOption.value; 
    });

  
});
